import React from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const SignInStore = require('../../stores/SignInStore');
const AccountActions = require('../../actions/AccountActions');
const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import AvatarButton from '../DashboardNew/Menu/AvatarButton';
const AvatarSelect = require('../ShortCourse/play/AvatarSelect');

const propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    buttonTitle: PropTypes.string,
};

const defaultProps = {
    className: '',
    disabled: false,
    buttonTitle: '',
};

const DEFAULT_HASH = "93c0295e48742e913c658cad22bfe825"; // hash with actual default img src

class AccountInfoEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signInStoreState: SignInStore.getState(),
            firstName: null,
            lastName: null,
            displayName: null,
            email: null,
            password: null,
            affiliation: null,
            updateInfoActionId: null,
            saveEnabled: false,
            showAvatarSelector: false,
            error: null,
        };

        this.onFirstNameChange = this.onFirstNameChange.bind(this);
        this.onLastNameChange = this.onLastNameChange.bind(this);
        this.onDisplayNameChange = this.onDisplayNameChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onAffiliationChange = this.onAffiliationChange.bind(this);
        this.saveHandler = this.saveHandler.bind(this);
        this.unsubscribes = [SignInStore.listen(this.onSignInStoreStateChange.bind(this))]
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreStateChange(newState) {
        let additionalState = {};

        if (newState.action.id === this.state.updateInfoActionId ) {
            additionalState = {
                ...additionalState,
                updateInfoActionId: null,
                firstName: null,
                lastName: null,
                avatar_name: null,
                avatar_hash: null, 
                displayName: null,
                affiliation: null,
                saveEnabled: !!newState.action.error, //disable save on successful action completion
                error: newState.action.error
            };
        }

        this.setState({ signInStoreState: newState, ...additionalState });
    }

    onFirstNameChange(e) {
        this.setState({ firstName: e.target.value, saveEnabled: true });
    }

    onLastNameChange(e) {
        this.setState({ lastName: e.target.value, saveEnabled: true });
    }

    onDisplayNameChange(e) {
        this.setState({ displayName: e.target.value, saveEnabled: true });
    }

    onPasswordChange(e) {
        this.setState({ password: e.target.value, saveEnabled: true });
    }

    onEmailChange(e) {
        return; // TODO: enable
        // this.setState({ email: e.target.value, saveEnabled: true });
    }

    onAffiliationChange(e) {
        this.setState({ affiliation: e.target.value, saveEnabled: true });
    }

    onAvatarSelect=(avatar_name,avatar_hash)=>{
        this.setState({ avatar_name, avatar_hash, saveEnabled: true });
    }

    toggleAvatarSelector=()=>{
        this.setState({showAvatarSelector: !this.state.showAvatarSelector});
    }

    saveHandler() {
        if (typeof this.state.password == 'string' && this.state.password.length < 8 ) {
            this.setState({ error: new ForgeError({ message: "Password must be 8+ characters" })});
            return;
        }

        if (typeof this.state.firstName == 'string' && this.state.firstName.length === 0 ) {
            this.setState({ error: new ForgeError({ message: "Please fill in the missing field" })});
            return;
        }

        if (typeof this.state.lastName == 'string' && this.state.lastName.length === 0 ) {
            this.setState({ error: new ForgeError({ message: "Please fill in the missing field" })});
            return;
        }

        if (typeof this.state.displayName == 'string' && this.state.displayName.length === 0 ) {
            this.setState({ error: new ForgeError({ message: "Please fill in the missing field" })});
            return;
        }

        const actionId = uuid.v4();
        this.setState({ updateInfoActionId: actionId, showAvatarSelector: false });
        AccountActions.updateAccountInfo(actionId, {
            userId: this.state.signInStoreState.userInfo.id,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            displayName: this.state.displayName,
            affiliation: this.state.affiliation,
            password: this.state.password,
            avatar_name: this.state.avatar_name,
            avatar_hash: this.state.avatar_hash,
        });
    }

    render() {
        const userInfo = this.state.signInStoreState.userInfo;
        // const defaultPortrait = GlobalConfig.StaticUrl + "/img/default-user-portrait.svg";

        let avatarName = this.state.avatar_name || userInfo.avatar_name || this.state.displayName || this.state.firstName;
        let avatarHash = this.state.avatar_hash || userInfo.avatar_hash || DEFAULT_HASH;

        return (
            <Row className={`${this.props.className}`}>
                <div className="col-12">
                    <h2>Account Information</h2>
                    <hr/>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <Form.Row>
                            <Form.Group controlId="settings-first-name" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.FIRST}</Form.Label>
                                <Form.Control
                                    type="text"
                                    aria-label={Strings['en'].user.profile.FIRST}
                                    disabled={this.props.disabled}
                                    value={typeof this.state.firstName === 'string' ? this.state.firstName : userInfo.first_name}
                                    onChange={this.onFirstNameChange}
                                    maxLength={Globals.users.profile.SIZE_FIRST}
                                />
                            </Form.Group>
                            <Form.Group controlId="settings-last-name" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.LAST}</Form.Label>
                                <Form.Control
                                    type="text"
                                    aria-label={Strings['en'].user.profile.LAST}
                                    disabled={this.props.disabled}
                                    value={typeof this.state.lastName === 'string' ? this.state.lastName : userInfo.last_name}
                                    onChange={this.onLastNameChange}
                                    maxLength={Globals.users.profile.SIZE_LAST}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group controlId="settings-display-name" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.DISPLAY}</Form.Label>
                                <Form.Control
                                    type="text"
                                    aria-label={Strings['en'].user.profile.DISPLAY}
                                    disabled={this.props.disabled}
                                    value={typeof this.state.displayName === 'string' ? this.state.displayName : userInfo.display_name}
                                    onChange={this.onDisplayNameChange}
                                    maxLength={Globals.users.profile.SIZE_DISPLAY}
                                />
                            </Form.Group>
                            <Form.Group controlId="settings-password" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.PASSWORD}</Form.Label>
                                <Form.Control
                                    type="password"
                                    aria-label={Strings['en'].user.profile.PASSWORD}
                                    disabled={this.props.disabled}
                                    value={typeof this.state.password === 'string' ? this.state.password : 'filler12'}
                                    onChange={this.onPasswordChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="settings-email" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.EMAIL}</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    aria-label={Strings['en'].user.profile.EMAIL}
                                    value={typeof this.state.email === 'string' ? this.state.email : userInfo.email}
                                    onChange={this.onEmailChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="settings-affiliation" bsPrefix="form-group col-12 col-sm-6">
                                <Form.Label>{Strings['en'].user.profile.PRO_AFF}</Form.Label>
                                <Form.Control
                                    type="text"
                                    aria-label={Strings['en'].user.profile.PRO_AFF}
                                    disabled={this.props.disabled}
                                    value={typeof this.state.affiliation === 'string' ? this.state.affiliation : userInfo.affiliation}
                                    onChange={this.onAffiliationChange}
                                    maxLength={Globals.users.profile.SIZE_AFFILIATION}
                                />
                            </Form.Group>
                        </Form.Row>
                    </Form>
                    <div className="settings-avatar">
                        <div className="labeled-button" onClick={this.toggleAvatarSelector}>
                            <label>{Strings['en'].user.profile.AVATAR}</label>
                            <AvatarButton userInfo={userInfo}/>
                            <span className={this.state.showAvatarSelector ? 'fa fa-caret-down' : 'fa fa-caret-right'}/>
                        </div>
                        {this.state.showAvatarSelector ? 
                        <AvatarSelect 
                            avatarPromptText={'Choose Avatar Name and Portrait'}
                            playButtonText={'Select'}
                            setPlayerNameAndHash={this.onAvatarSelect} 
                            defaultPlayerName={avatarName} 
                            defaultAvatarHash={avatarHash} />
                        : null }
                    </div>
                    <Form.Row>
                        <Button
                            disabled={this.props.disabled || !this.state.saveEnabled || !!this.state.updateInfoActionId}
                            onClick={this.saveHandler}
                            title={this.props.buttonTitle}
                        >
                            {Strings['en'].user.settings.SAVE_BTN_LBL}
                        </Button>
                    </Form.Row>
                </div>
            </Row>
        );
    }
}

AccountInfoEdit.propTypes = propTypes;
AccountInfoEdit.defaultProps = defaultProps;

export default AccountInfoEdit;